import { render } from "./MyProfileUserLimits.vue?vue&type=template&id=0cb2f943"
import script from "./MyProfileUserLimits.vue?vue&type=script&lang=js"
export * from "./MyProfileUserLimits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__